<template>
  <el-form
    :model="params"
    inline
    class="base-filter"
    ref="form"
  >
    <template v-for="{ prop, componentName, defaultValue } in componentList">
      <el-form-item
        :key="prop"
        :prop="prop"
      >
        <slot
          v-if="$scopedSlots[prop]"
          :name="prop"
        />
        <component
          v-else-if="componentName"
          v-model="params[prop]"
          v-bind="selectAttrs[prop]"
          :is="componentName"
          :clearable="defaults.includes(prop) ? defaultClearable : true"
          :attr="prop"
          :default="defaultValue"
          :params="params"
          :router="router"
          :multiple="multiple.includes(prop)"
          collapse-tags
          :set-default="setDefault"
          @set-default="handleSetDefault(prop, $event)"
          @keypress.enter.native="search(true)"
          @change="handleChange(prop, $event)"
          @query-change="queryChange"
          @label-change="labels = { ...labels, [prop]: $event }"
          ref="com"
        />
      </el-form-item>
    </template>
    <slot />
    <el-form-item>
      <el-button
        type="primary"
        plain
        @click="search(true)"
      >确定</el-button>
      <el-button
        type="default"
        plain
        @click="reset"
      >重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'BaseFilter',

  componentName: 'BaseFilter',

  props: {
    value: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    defaults: {
      type: Array,
      default: () => []
    },
    defaultClearable: Boolean,
    props: {
      type: Object,
      default () {
        return {}
      }
    },
    resetPage: {
      type: Boolean,
      default: true
    },
    pageKey: {
      type: String,
      default: 'page'
    },
    router: Boolean,
    searchOnInit: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Array,
      default: () => [ 'iterm' ]
    },
    searchOnChange: Function,
    selectAttrs: {
      type: Object,
      default () {
        return {}
      }
    },
    unbind: Boolean,
    setDefault: Function
  },

  computed: {
    componentList () {
      return this.options.reduce((o, prop) => {
        const componentName = this.props[ prop ]
        const defaultValue = this.defaults.includes(prop)
        o.push({ prop, componentName, defaultValue })
        return o
      }, [])
    },
    store () {
      const { com } = this.$refs
      const vm = Array.isArray(com) ? com.find(item => item.store) : com
      return vm ? vm.store : {}
    },
    isCurrent () {
      return this.$route.name === this.current
    },
    queryCount () {
      const query = this.$route.query.q && this.q ? this.q : this.$route.query
      let i = 0
      for (const k in query) {
        if (k in this.props && query[ k ]) {
          i++
        }
      }
      return i
    }
  },

  created () {
    // 初始触发search事件
    if (this.searchOnInit && this.defaults.length === 0 && this.isCurrent && !this.router) {
      this.search(true)
    }
  },

  activated () {
    // 用于keep-alive时重新加载数据
    if (this.oldParams && this.searchOnInit && this.isCurrent && !this.router) {
      const flag = Object.entries(this.oldParams).some(([ key, val ]) => this.$route.params[ key ] !== val)
      flag && this.search(true)
    }
    if (this.isCurrent) {
      this.oldParams = this.$route.params
    }
  },

  watch: {
    value: {
      handler (value, oldValue) {
        this.params = { ...value }
      },
      immediate: true,
      deep: true
    }
  },

  data () {
    return {
      defaultValue: { ...this.value },
      params: { ...this.value },
      count: 0, // 标记默认项加载数
      queryChangeNum: 0, // 查询参数回显的个数
      current: this.$route.name,
      labels: {}
    }
  },

  methods: {
    search (emit) {
      // keep-alive导致在路由跳转时会触发上一个页面更新
      if (!this.isCurrent) return
      if (this.resetPage && this.params.hasOwnProperty(this.pageKey)) {
        this.params[ this.pageKey ] = 1
      }
      if (emit && !this.unbind) {
        this.$emit('input', Object.assign(this.value, this.params))
      }
      this.$emit('search', { ...this.params })
      this.$nextTick(() => {
        this.$emit('field-label', this.labels)
      })
    },
    // 重置
    reset () {
      this.params = { ...this.defaultValue }
      !this.unbind && this.$emit('input', Object.assign(this.value, this.params))
      this.search()
    },
    handleSetDefault (prop, value) {
      if (!this.defaultClearable) {
        this.defaultValue[ prop ] = value
      }
      // keep-alive导致在路由跳转时会触发上一个页面更新
      if (!this.isCurrent) return
      this.count++
      this.params[ prop ] = value
      if (this.count === this.defaults.length && this.searchOnInit) {
        // 在同时开启查询参数与默认值的情况下的处理
        if (this.router && this.queryChangeNum !== this.queryCount) return
        !this.unbind && this.$emit('input', Object.assign(this.value, this.params))
        this.search()
      }
    },
    // 根据查询参数复现筛选框数值的操作
    queryChange () {
      this.queryChangeNum++
      if (this.queryChangeNum === this.queryCount) {
        // 在同时开启查询参数与默认值的情况下的处理
        if (this.count !== this.defaults.length && this.searchOnInit) return
        !this.unbind && this.$emit('input', Object.assign(this.value, this.params))
        this.search()
        this.queryChangeNum = 0
      }
    },
    handleChange (prop, value) {
      !this.unbind && this.$emit('input', { ...this.value, ...this.params, [ prop ]: value })
      if (this.searchOnChange && this.searchOnChange(prop)) {
        this.search()
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .base-filter >>> .el-select__tags-text {
    display: inline-block;
    max-width: 88px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }
</style>
